const testimonials = [
  {
    name: "Jim D.",
    location: "St. Joseph, MO — Cattle Industry",
    rating: 5,
    text: "I am a cattle buyer and had a purchasing trip to Saskatchewan, Canada come up on two weeks notice. My passport had expired a year ago. I assumed I'd have to race to Kansas City and beg for an appointment. Found Fast Passport Center, shipped my documents from the St. Joseph UPS overnight, and had my passport back in 6 business days. Got to Canada on time and closed a great deal. These people saved my business trip.",
    service: "Emergency Renewal",
  },
  {
    name: "Emily R.",
    location: "St. Joseph, MO — MWSU Student",
    rating: 5,
    text: "I was accepted into a summer program in Spain and had 5 weeks before the program started. I had never had a passport before — had no idea what to do. Fast Passport Center walked me through the acceptance clerk process at the St. Joseph post office, helped me prepare every document correctly, and I got my first passport back in time for orientation. Could not have done it without them.",
    service: "First Passport",
  },
  {
    name: "Tom & Mary S.",
    location: "Savannah, MO — Retired",
    rating: 5,
    text: "We planned a river cruise through Europe and found out three weeks before departure that Tom's passport had expired. Calling Fast Passport Center was the best decision we made. They were calm, professional, told us exactly what to do, and Tom's renewed passport arrived 9 days later. We made our cruise departure from Amsterdam with days to spare. Highly recommend to anyone in Northwest Missouri.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function StJosephTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What St. Joseph &amp; Northwest Missouri Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real experiences from St. Joseph, Savannah, and Buchanan County travelers who trusted Fast Passport Center with their expedited passport needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}